import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { CabsandTakeTemplateAddPage } from './cabsand-take-template-add';

@NgModule({
  declarations: [
    CabsandTakeTemplateAddPage,
  ],
  imports: [
    IonicPageModule.forChild(CabsandTakeTemplateAddPage),
  ],
})
export class CabsandTakeTemplateAddPageModule {}



// WEBPACK FOOTER //
// ./src/pages/cabsand-take-template-add/cabsand-take-template-add.module.ts